import React, { useEffect, useState } from "react";
import { API } from "../../config/api";
import { useNavigate, useParams } from "react-router-dom";
import { DELETE, GET, PUT } from "../../utils/apicalls";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  notification,
  Row,
  Select,
} from "antd";
import { Container } from "react-bootstrap";
import Type from "../employee/helpers/type.json";
import PageHeader from "../pageHeader/pageheader";

function Viewuser() {
  const [UsersData, setUsersData] = useState<any>();
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getUserData();
  }, []);

  const getUserData = async () => {
    try {
      let api = API.GET_ONE + id;
      const Data: any = await GET(api, {});
      setUsersData(Data?.data);
      form.setFieldsValue(Data?.data);
    } catch (error) {
      console.log("Error fetching user data:", error);
    }
  };

  const onFinish = async (values: any) => {
    try {
      let obj = {
        type: values.type,

        firstName: values.firstName,
        lastName: values.lastName,
        fullName: values.fullName,
        userName: values.userName,
        password: values.password,
        email: values.email,
        officeEmail: values.officeEmail,
        phone: values.phone,
        altPhone: values.altPhone,
        gender: values.gender,
        department: values.department,
        wrok_status: values.wrok_status,
        dob: values.dob,
        hireDate: values.hireDate,
        address: values.address,
        status: true,
        accountNo: values.accountNo,
        bankName: values.bankName,
        ifsc: values.ifsc,
        branch: values.branch,
        accountName: values.accountName,
        salary: Number(values.salary),
        id_Type: values.id_Type,
        id_Number: values.id_Number,
        id_Image1: values.id_Image1,
        bloodGroup: values.bloodGroup,
      };
      let api = API.EMPLOYEE_UPDATE + id;
      const postRequest: any = await PUT(api, obj);

      if (postRequest) {
        notification.success({
          message: "Employee details updated successfully",
        });
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    }
  };
  const [file, setFile] = useState(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      const reader: any = new FileReader();
      reader.onloadend = () => {
        if (reader?.result) {
          setFile(reader?.result);
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = API.DELETE_EMPLOYEE + id;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "Employee Deleted Successfully" });
        navigate(-1);
      } else {
        notification.error({
          message: "Something went wrong!! Please try again later",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong!! Please try again later",
      });
    } finally {
      setIsModalOpen(false);
      setIsLoading(false);
    }
  };

  const confirmDelete = () => {
    // Show a confirmation dialog before deleting
    const confirm = window.confirm(
      "Are you sure you want to delete this employee?"
    );
    if (confirm) {
      handleDelete(id);
    }
  };

  return (
    <Container>
      <PageHeader />
      <Card className="user-details-card">
        {/* <div className="header">
          <u>
            <span>Employee Details</span>
          </u>
          <Button onClick={() => navigate("/Admin/Dashboard")}>Back</Button>
        </div> */}

        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={[16, 24]}>
            <Col sm={6}>
              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true, message: "Please select type" }]}
              >
                <Select placeholder="Select Type">
                  {Type?.map((des) => (
                    <Select.Option key={des.value} value={des.value}>
                      {des.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="fullName"
                label="Full Name"
                rules={[
                  { required: true, message: "Please enter your full name" },
                ]}
              >
                <Input placeholder="Enter full name" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="firstName"
                label="firstName"
                rules={[
                  { required: true, message: "Please enter your full name" },
                ]}
              >
                <Input placeholder="Enter full name" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="lastName"
                label="lastName"
                rules={[
                  { required: true, message: "Please enter your full name" },
                ]}
              >
                <Input placeholder="Enter full name" className="input-style" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="userName"
                label="userName"
                rules={[
                  { required: true, message: "Please enter your username" },
                ]}
              >
                <Input placeholder="Enter username" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="password"
                label="password"
                rules={[
                  { required: true, message: "Please enter your username" },
                ]}
              >
                <Input placeholder="Enter username" className="input-style" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "Please enter your email",
                    type: "email",
                  },
                ]}
              >
                <Input placeholder="Enter email" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="officeEmail"
                label="Office Email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Enter valid Office Email",
                  },
                ]}
              >
                <Input placeholder="Office Email" />
              </Form.Item>
            </Col>

            <Row gutter={[16, 24]}>
              <Col sm={6}>
                <Form.Item
                  name="phone"
                  label="Phone"
                  rules={[{ required: true, message: "Enter Phone Number" }]}
                >
                  <Input placeholder="Phone" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="address" label="Address">
                  <Input placeholder="Enter address" className="input-style" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item name="altPhone" label="Alternate Number">
                  <Input
                    placeholder="Enter alternate number"
                    className="input-style"
                  />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[{ required: true, message: "Select Gender" }]}
                >
                  <Select placeholder="Select Gender">
                    <Select.Option value="Male">Male</Select.Option>
                    <Select.Option value="Female">Female</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="department"
                  label="Department"
                  rules={[{ required: true, message: "Enter Department" }]}
                >
                  <Input placeholder="Department" />
                </Form.Item>
              </Col>
              {/* <Col sm={6}>
                <Form.Item name="work_status" label="Work Status">
                  <Input placeholder="Work Status" />
                </Form.Item>
              </Col> */}
              {/* <Col sm={6}>
                <Form.Item
                  name="dob"
                  label="Date of Birth"
                  rules={[{ required: true, message: "Select Date of Birth" }]}
                ></Form.Item>
              </Col> */}
              {/* <Col sm={6}>
                <Form.Item
                  name="hireDate"
                  label="Hire Date"
                  rules={[{ required: true, message: "Select Hire Date" }]}
                >
                  <DatePicker value={moment()} />
                </Form.Item>
              </Col> */}
              <Col sm={6}>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[{ required: true, message: "Enter Address" }]}
                >
                  <Input.TextArea placeholder="Address" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item name="accountNo" label="Account Number">
                  <Input placeholder="Account Number" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="bankName" label="Bank Name">
                  <Input placeholder="Bank Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="ifsc" label="IFSC Code">
                  <Input placeholder="IFSC Code" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="branch" label="Branch">
                  <Input placeholder="Branch" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="accountName" label="Account Name">
                  <Input placeholder="Account Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="salary"
                  label="Salary"
                  rules={[{ required: true, message: "Enter Salary" }]}
                >
                  <Input placeholder="Salary" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="id_Type" label="ID Type">
                  <Input placeholder="ID Type" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="id_Number" label="ID Number">
                  <Input placeholder="ID Number" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="id_Image1"
                  label="ID Image"
                  rules={[
                    { required: true, message: "Please upload your ID image" },
                  ]}
                >
                  <div>
                    <Input type="file" onChange={handleChange} />
                    {file && (
                      <img
                        src={file}
                        alt="ID Preview"
                        style={{ maxWidth: "100%", marginTop: "10px" }}
                      />
                    )}
                  </div>
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="bloodGroup" label="Blood Group">
                  <Input placeholder="Blood Group" />
                </Form.Item>
              </Col>
            </Row>
          </Row>

          {/* Buttons */}
          <Row className="mt-4" gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Button
                onClick={() => navigate("/Admin/Dashboard")}
                size="large"
                block
                className="cancel-button"
              >
                Cancel
              </Button>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                block
                className="update-button"
              >
                Update
              </Button>
            </Col>
            <Col sm={8}>
              <Button
                size="large"
                style={{ backgroundColor: "red" }}
                className="update-button"
                onClick={confirmDelete}
              >
                Delete
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </Container>
  );
}

export default Viewuser;
